import { observer } from 'mobx-react-lite'
import classnames from 'classnames'
import { Box, type ITabItem, Scrollbar, Tabs } from 'shared/ui'
import { useReviewViewContext } from 'pages/reviews/context'
import { type ITabType } from 'pages/reviews/store/type'
import { PreviewFooter } from 'pages/reviews/ui/Preview/PreviewFooter'
import { PreviewAppearance } from './PreviewAppearance'
import { PreviewHappy } from './PreviewHappy'
import { PreviewUnhappy } from './PreviewUnhappy'
import styles from './styles.module.scss'

type IPreviewProps = {
  isModal?: boolean
}

export const Preview = observer(({ isModal = false }: IPreviewProps) => {
  const { activeTab, setActiveTab, setScrollToStep, bgColor, isFontColorWhite } =
    useReviewViewContext()
  const tabs: ITabItem<ITabType>[] = [
    { key: 'appearance', name: 'Appearance' },
    { key: 'happy', name: 'Stars (4-5)' },
    { key: 'unhappy', name: 'Stars (1-3)' },
  ]

  const handleTabChange = (tab: ITabItem<ITabType>) => {
    setActiveTab(tab.key)
    setScrollToStep(tab.key)
  }

  return (
    <Box className={classnames(styles.wrap, { [styles.modal]: isModal })}>
      <Tabs
        tabs={tabs}
        tabsClassName={styles.tab}
        tabHeight={40}
        activeTabKey={activeTab}
        handleSelectTab={handleTabChange}
      />

      <Scrollbar>
        <div className={styles.preview}>
          <div className={styles.preview__layer}>
            <div
              className={styles.preview__layerWrap}
              style={{
                backgroundColor: bgColor,
                color: isFontColorWhite
                  ? 'var(--content-primary-primary-inverted)'
                  : 'var(--content-primary-primary)',
              }}
            >
              <Scrollbar>
                {activeTab === 'appearance' && <PreviewAppearance />}
                {activeTab === 'happy' && <PreviewHappy />}
                {activeTab === 'unhappy' && <PreviewUnhappy />}
              </Scrollbar>
              <PreviewFooter />
            </div>
          </div>
        </div>
      </Scrollbar>
    </Box>
  )
})
